<template>
    <div style="margin-left: 30px;margin-top: -20px;">

        <el-row>
            <el-col :span="12">
                <el-menu :default-active="activeIndex" mode="horizontal" @select="handleOpen">
                    <el-menu-item index="1">
                        <span>排课车厢</span>
                    </el-menu-item>
                    <el-menu-item index="2">
                        <span>修改记录</span>
                    </el-menu-item>
                </el-menu>
            </el-col>
            <el-col :span="12">
                <el-button v-if="Acs('/customer/accounts/migrate-olddata')" type="success" size="small" @click="showPaikeDialog = true">同步旧版数据</el-button>
                <el-tooltip class="item" effect="light" placement="right" :value="true">
                    <div slot="content" style="color: #F56C6C;font-size: 14px"><b>
                        <i class="el-icon-message-solid"></i>修改配置后请点击此处保存</b>
                    </div>
                    <el-button size="small" type=primary @click="submit">确定</el-button>
                </el-tooltip>
            </el-col>
        </el-row>
        <div v-show="activeIndex==1"> 
            <el-tabs v-model="activeTab" type="card" @tab-click="triggerSwitch" @tab-remove="removeTab">
                <el-tab-pane v-for="(licence, key) in licences"
                    :label="licence.schoolId.toString() == '0' ? '新增未保存' : licence.schoolName + '(' + licence.schoolId.toString() + ')'"
                    :name="licence.schoolId.toString()" :closable="allowAddOrDel" :key="key">

                    <div style="margin-top: 20px;"></div>

                    <el-form :model="form" ref="form" label-width="120px" :inline-message=true>
                        <el-form-item label="订单类型：" prop="radio">
                            <el-radio-group v-model="form.type" :disabled="is_disabled && licence.schoolId.toString() !== '0'">
                                <el-radio :label="1">试用</el-radio>
                                <el-radio :label="2">新增</el-radio>
                                <el-radio :label="3">续费</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="产品开关：">
                            <el-switch v-model="form.is_enable" :active-value="1" :inactive-value="0" active-text="开启" inactive-text="关闭">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="开始时间：">
                            <el-date-picker v-model="form.start_at" :disabled="is_disabled && licence.schoolId.toString() !== '0'" type="date" placeholder="选择日期"
                                value-format="timestamp" format="yyyy 年 MM 月 dd 日">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束时间：">
                            <el-date-picker :disabled="is_disabled && licence.schoolId.toString() !== '0'" v-model="form.end_at" type="date" placeholder="选择日期"
                                value-format="timestamp" format="yyyy 年 MM 月 dd 日">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="排课车厢名称：">
                            <el-input style="width: 300px" placeholder="请输入车厢名称" v-model="form.schoolName">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="排课ID：" class="limit-configure">
                            <el-col :span="4" v-if="form.limit_configure.schoolId && form.limit_configure.schoolId !== '0'">
                                {{ form.limit_configure.schoolId }}
                            </el-col>
                        </el-form-item>
                        <el-form-item label="排课查询密码：" class="limit-configure">
                            <el-input v-model.number="form.queryCode" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="备注：">
                            <el-input style="width: 300px" type="textarea" :rows="2" placeholder="请输入内容" v-model="form.memo">
                            </el-input>
                        </el-form-item>
                    </el-form>


                    <div slot="footer" class="dialog-footer" style="text-align: center"></div>

                    <account-settings 
                        ref="accountRef" 
                        :schoolId="form.schoolId.toString()" 
                        :customer_id="$route.query['id']" 
                        :product_id="form.product_id"
                        :accounts="form.accounts" 
                        @relationAccount="relationAccount" 
                        @changeAccount="changeAccount"
                        @afterDeleteDevice="afterDeleteDevice"
                        >
                    </account-settings>

                </el-tab-pane>
                <el-tab-pane v-if="allowAddOrDel" name="addTab" :disabled="true" :closable="false">
                    <span slot="label">
                        <el-link type="primary" @click="addTab"><i class="el-icon-plus"></i> 新增排课</el-link>
                    </span>
                </el-tab-pane>
            </el-tabs>
            <paike-data v-if="showPaikeDialog" :key="form.schoolId" :schoolId="form.schoolId" :display="showPaikeDialog"
            @callback="watchPaikeData"></paike-data>
        </div>
        <div v-if="activeIndex==2">
            <Recorder :customer_id="$route.query['id']" :product_id="form.product_id" :product_list="params.product_list"></Recorder>
        </div>


    </div>
</template>

<style scoped>
.app-main .main-bd .el-row {
    padding: 10px 0;
}
</style>
<script>
import LimitConfigure from "~/views/order/paike/limitConfigure.vue";
import CommonService from "~/services/common";
import Config from "~/config/params";
import RelationForm from "~/views/customer/relationForm.vue";
import RelationDialog from "~/views/customer/dialog/relationDialog.vue";
import ProductHead from "~/views/order/partial/product_head.vue";
import OrderService from "~/services/order";
import AccountSettings from "~/views/order/paike/AccountSettings.vue";
import CustomerAccounts from "~/services/CustomerAccounts";
import PaikeData from "~/views/customer/dialog/PaikeData.vue";
import Recorder from "~/views/order/recoder/base.vue";


export default {
    components: {
        PaikeData,
        LimitConfigure,
        RelationForm,
        RelationDialog,
        ProductHead,
        AccountSettings,
        Recorder
    },
    data() {
        return {
            is_submit: false,
            is_ajax_loading: false,
            validate_init: true,
            validate_limit_configure: false,
            form: {
                customer_id: this.$route.query['id'],
                order_id: '',
                product_id: '',
                init: {},
                limit_configure: {
                    schoolId: ''
                },
                queryCode: '',
                is_enable: '',
                accounts: [],
                start_at: '',
                end_at: '',
                type: '',
                quantity: 1,
                memo: '',
                schoolName: '',
            },
            timeTableInfo: {},
            licences: [],
            licencesMap: new Map(),
            activeIndex: '1',
            formLabelWidth: '120px',
            showPaikeDialog: false,
            activeTab: '',
            is_disabled: true,

            startTime: '',
            endTime: '',
            existPaikeAccount: [],
            allowAddOrDel : false
        }
    },
    props: {
        params: {
            required: true
        }
    },
    created() {

        // 是否有编辑权限
        if (this.Acs('/order/supervisorProduct')) {
            this.is_disabled = false;
        }

        if (this.Acs('/common/delete-paike')) {
            this.allowAddOrDel = true;
        }

        this.form.limit_configure.product_code = this.params.product_code;
        this.form.product_id = this.params.product_id;
        this.form.order_id = this.params.order_id;
        // this.form.type = this.params.open_state;
        this.form.memo = this.params.memo;
        this.getTimetableInfo(this.$route.query['id']);
        // if (this.timeTableInfo.endAt != '') {
        //     this.form.end_at = this.timeTableInfo.endAt;
        // } else {
        //     this.form.end_at = this.params.end_at;
        // }

        // this.form.is_enable = this.timeTableInfo.isActive;
        // if (this.timeTableInfo.startAt != '') {
        //     this.form.start_at = this.timeTableInfo.startAt;
        // } else {
        //     this.form.start_at = this.params.start_at;
        // }
        // this.form.accounts = this.timeTableInfo.accounts
    },
    methods: {

        getTimetableInfo(customerId) {
            //获取排课基本设置
            CommonService.getTimeTableInfo({
                customer_id: customerId,
            }).then(res => {
                this.timeTableInfo = res.data
                this.licences = [...res.data];
                if (res.data.length > 0) {

                    this.licencesMap = new Map();
                    for (let i = 0; i < res.data.length; i++) {
                        this.licencesMap.set(res.data[i].schoolId, res.data[i]);
                    }

                    let firstLicence = res.data[0];
                    if (firstLicence) {
                        this.activeTab = firstLicence.schoolId.toString();
                        this.form.schoolId = firstLicence.schoolId;
                        this.form.limit_configure.schoolId = firstLicence.schoolId;
                        this.form.start_at = firstLicence.startAt;
                        this.form.end_at = firstLicence.endAt;
                        this.form.accounts = [...firstLicence.accounts];
                        this.form.is_enable = firstLicence.isActive;
                        this.form.queryCode = firstLicence.queryCode;
                        this.form.type = parseInt(firstLicence.openState);
                        this.startTime = this.form.start_at.toString();
                        this.endTime = this.form.end_at.toString();
                        this.form.memo = firstLicence.memo;
                        this.form.schoolName = firstLicence.schoolName;
                    }
                }
            });
        },

        /**
         * 关联账号
         * */
        relationAccount(data, cb) {


            let otherSchoolAccountSet = new Set();
            this.licencesMap.forEach((value, key) => {
                if (key.toString() !== this.activeTab) {
                    value.accounts.forEach(item => {
                        if (item.userId != null && item.userId != '') {
                            otherSchoolAccountSet.add(item.userId.toString());
                        }
                    });
                }
            });

            let accounts = [];
            if (data && data.length > 0) {
                for (let item of data) {
                    // 过滤已添加在别的学校的账号
                    if (otherSchoolAccountSet.has(item.user_id.toString())) {
                        continue;
                    }

                    let account = {
                        customerId: item.customer_id,
                        userId: item.user_id,
                        username: item.username,
                        realName: item.real_name,
                        isActive: 1,
                        deviceList: []
                    };

                    accounts.push(account);
                }
            }

            let oldSchollId = this.form.schoolId;
            
            this.form.schoolId = '';
            this.form.schoolId = oldSchollId;

            //this.form.accounts = accounts;

            this.$set(this.form, 'accounts', accounts);


            //这里需要提交一下service接口去开通排课并将账号
            let _this = this;
            this.form.before_content = this.buildBeforeContent();
            OrderService.reviseProduct(this.form).then(res => {
                if (res.code == 0) {
                    this.$message({
                        message: res.msg == 'success' ? Config.REVISE_NOTICE : res.msg,
                        type: 'success'
                    });

                    _this.getTimetableInfo(this.$route.query['id']);
                }
                this.is_submit = false;
            }).catch(err => {
                this.is_submit = false;
                console.error(err);
            });

            this.form.is_submit = false;

            this.$forceUpdate();
        },
        //获取查询密码
        queryCode(data) {
            this.form.queryCode = data.queryCode;
            this.form.memo = data.memo;
            this.form.schoolName = data.schoolName;
        },
        /**
         * 修改头部信息
         * @param data
         */
        changeHead(data) {
            this.form.type = data.type;
            this.form.end_at = data.end_at;
            this.form.is_enable = data.is_enable;
            this.form.start_at = data.start_at;
        },
        changeAccount(data) {
            this.form.accounts = data.accounts
        },

        watchPaikeData(cb, status) {
            this.showPaikeDialog = status;
        },

        /**
         * 迁移旧数据
         **/
        migrateOldData() {

            this.$prompt('旧版学校ID', '同步旧版数据', {
                confirmButtonText: '同步',
                cancelButtonText: '取消',
                inputPattern: /\S/,
                inputErrorMessage: '旧版学校ID'
            }).then(({ value }) => {
                var Regx = /^[0-9]*$/;
                if (!Regx.test(value)) {
                    this.$message({
                        message: '只能输入数字',
                        type: 'error'
                    });
                    return false
                }

                CustomerAccounts.migrateOlddata(this.form.limit_configure.schoolId, value).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: '迁移成功',
                            type: 'success'
                        });
                    }

                });

            });
        },

        /**
         * 表单提交
         * */
        submit() {

            if (this.form.start_at == '' || this.form.end_at == '') {
                this.$message({
                    message: '请选择开始时间和结束时间',
                    type: 'error'
                });
                return false;
            }

            if (this.is_submit) return false;
            this.is_submit = true;
            if (!this.validate_init) return false;

            if (this.form.accounts && this.form.accounts.length > 0) {
                this.form.accounts = this.form.accounts.filter(item => item.userId != null || item.username != null);
            }

            // 多个产品设定
            this.form.quantity = this.licences.length;
            this.form.before_content = this.buildBeforeContent();

            let _this = this;
            OrderService.reviseProduct(this.form).then(res => {
                this.is_submit = false;
                if (res.code == 0) {
                    this.$message({
                        message: res.msg == 'success' ? Config.REVISE_NOTICE : res.msg,
                        type: 'success'
                    });
                    // CommonService.getTimeTableInfo({
                    //     customer_id: this.$route.query['id'],
                    // }).then(res => {
                    //     this.timeTableInfo = res.data
                    //     if (res.data.length != 0) {
                    //         this.form.limit_configure.schoolId = res.data[0].schoolId
                    //     }

                    // });
                    _this.getTimetableInfo(this.$route.query['id']);
                }
            });
        },
        /**@description 监听子组件数据 */
        handleData(data) {
            this.form.limit_configure = data
        },

        buildBeforeContent() {
            const schoolId = Number(this.form.schoolId);
            const licence = this.licencesMap.get(schoolId)
                || this.licences.find(item => Number(item.schoolId) === schoolId);

            if (!licence) {
                return {};
            }

            return {
                schoolId: licence.schoolId,
                schoolName: licence.schoolName || '',
                type: parseInt(licence.openState, 10),
                is_enable: Number(licence.isActive),
                start_at: this.toTimestamp(licence.startAt),
                end_at: this.toTimestamp(licence.endAt),
                memo: licence.memo || ''
            };
        },

        toTimestamp(value) {
            if (typeof value === 'number') {
                return value < 100000000000 ? value * 1000 : value;
            }

            if (typeof value === 'string' && /^\d+$/.test(value)) {
                const timestamp = Number(value);
                return timestamp < 100000000000 ? timestamp * 1000 : timestamp;
            }

            const timestamp = new Date(value).getTime();
            return isNaN(timestamp) ? '' : timestamp;
        },
        handleOpen(key, keyPath) {
            if (key == 3) {
                return false;
            }
            this.activeIndex = key;
        },

        async beforeLeave() {
            var p = new Promise((resolve, reject) => {
                if (this.activeTab === '0') {
                    this.$message({
                        message: '当前新增配置未保存，请先保存再进行其他操作',
                        type: 'error'
                    });
                    reject();
                } else {
                    resolve();
                }
            })
            return p
        },

        triggerSwitch(tab, event) {
            let schoolId = parseInt(tab.name);
            if (schoolId === 0) {
                this.initEmptyForm();
                return;
            }

            if (!this.licencesMap.has(schoolId)) {
                this.$message({
                    message: '无效的学校ID',
                    type: 'error'
                });
                return false;
            }

            let licence = this.licencesMap.get(schoolId);
            
            this.form.schoolId = schoolId;
            this.form.limit_configure.schoolId = schoolId;
            this.form.start_at = licence.startAt;
            this.form.end_at = licence.endAt;
            this.form.accounts = [...licence.accounts].filter(item => item.userId != null || item.username != null);
            this.form.is_enable = licence.isActive;
            this.form.queryCode = licence.queryCode;
            this.form.memo = licence.memo;
            this.form.schoolName = licence.schoolName;
            this.form.type = parseInt(licence.openState);
            this.form.is_enable = licence.isActive;
            this.params.start_at = licence.startAt;
            this.params.end_at = licence.endAt;

            this.startTime = this.form.start_at.toString();
            this.endTime = this.form.end_at.toString();

            this.$forceUpdate();
        },

        addTab() {

            if (this.licences.length > 0) {
                for (let i = 0; i < this.licences.length; i++) {
                    if (this.licences[i].schoolId == '0') {
                        this.$message({
                            message: '请先保存当前未保存的新增配置',
                            type: 'error'
                        });
                        return false;
                    }
                }
            }

            if (this.licences.length >= 50) {
                this.$message({
                    message: '最多只能添加50个学校',
                    type: 'error'
                });
                return false;
            }

            this.licences.push({
                schoolId: '0',
                schoolName: this.params.customer.name,
                customerId: this.params.customer.id,
                queryCode: this.form.queryCode,
                openState: this.form.is_enable,
                startAt: "",
                endAt: "",
                isActive: 1,
                accounts: [],
                memo: "",
                schoolName: ''
            });

            this.initEmptyForm();
        },

        initEmptyForm() {
            this.form.starAt = "";
            this.form.endAt = "";
            this.form.type = 1;
            this.form.accounts = []
            this.form.limit_configure.schoolId = "";
            this.form.schoolId = "";
            this.form.queryCode = "";
            this.form.memo = "";
            this.activeTab = "0";
            this.form.schoolName = '';
        },

        afterDeleteDevice() {
            this.$message({
                message: '操作成功',
                type: 'success'
            });

            this.getTimetableInfo(this.$route.query['id']);
        },
        
        async removeTab(tab) {

            if (tab.toString() === '0') {
                this.licences = this.licences.filter(item => item.schoolId.toString() !== tab.toString());
                // 防止删除后，没有tab被选中导致样式空白
                if (this.licences.length > 0) {
                    let firstLicence = this.licences[0];
                    this.activeTab = firstLicence.schoolId.toString();
                    this.triggerSwitch({name: this.activeTab});
                }
                return;
            }
            
            if (this.licences.length <= 1) {
                this.$message({
                    message: '至少保留一个学校配置',
                    type: 'error'
                });
                return false;
            }

            // 同步阻塞确认框
            const isOK = await this.$confirm('确认删除该学校配置吗？', '提示', {
                confirmButtonText: '确定删除',
                cancelButtonText: '我再想想',
                type: 'error'
            }).catch(err => {
                return false;
            });

            if (!isOK) {
                return;
            }

            let _this = this;
            CommonService.deletePaike(tab).then(res => {
                if (res.code == 0) {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    _this.getTimetableInfo(this.$route.query['id']);
                }
            });
        },

    }
}
</script>




// WEBPACK FOOTER //
// src/views/order/paike/paikeNewConfigure.vue